import { HttpClient, HttpHeaders, HttpParams, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';

import { CategoriesModel, SportsModel, TournamentsModel } from '../categories';

declare let $;
declare let langCode;
declare let langId;
declare let langs;
declare let timeZone;
@Injectable()
export class CategoriesService {
    public sports: SportsModel[];
    public categoriesModel: CategoriesModel[];
    private apisUrl = '/API/';
    constructor(private http: HttpClient) {
        // http.request(this.apisUrl + '/Sports/' + langId)
        //    .map((response: Response) => <SportsModel[]>response.json())
        //    .subscribe(response => this.sports = response,
        //    err => console.log(err),
        //    () => console.log('Ok'));
    }

    public getSportObservable(hour) {
        return this.http
            .get(this.apisUrl + '/Sports/' + langId + '/' + hour)
            .pipe(map((response: Response) => (response.json() as unknown) as SportsModel[]));
    }
    public getCategoryObservable(sportId, hour) {
        return this.http
            .get(this.apisUrl + '/Countries/' + sportId + '/' + langId + '/' + hour)
            .pipe(map((response: Response) => (response.json() as unknown) as CategoriesModel[]));
    }
    public getTournamentObservable(sportId, categoryId, hour) {
        return this.http
            .get(this.apisUrl + '/TournamentsByCategoryId/' + sportId + '/' + categoryId + '/' + langId + '/' + hour)
            .pipe(map((response: Response) => (response.json() as unknown) as TournamentsModel[]));
    }
}
